import { getEnvironment } from './env';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export const appInsights = new ApplicationInsights({
	config: {
		instrumentationKey: getEnvironment().ai_key,
	},
});